import React from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';
import '../styles/wasp-system.css';

const waspData = {
  title: 'AI 말벌 퇴치 시스템',
  overview:
    'AI 기반 실시간 말벌 감지 및 친환경 자동 퇴치 시스템. 농장, 공원 등 다양한 환경에서 말벌을 효과적으로 감지하고 퇴치합니다.',
  images: {
    monitoring: '/images/wasp-monitoring.jpg',
    hardware: '/images/wasp-hardware.jpg',
    system: '/images/wasp-system.jpg',
  },
  features: [
    {
      title: '실시간 모니터링',
      items: ['AI 기반 말벌 감지', '실시간 영상 분석', '위험 알림 시스템'],
    },
    {
      title: '친환경 퇴치 하드웨어',
      items: ['자동 퇴치 장치', '친환경 퇴치 방식', '저전력 설계'],
    },
    {
      title: '데이터 분석',
      items: ['말벌 출현 패턴 분석', '환경 데이터 수집', '효율적 방제 전략 제공'],
    },
  ],
};

const WaspSystem = () => {
  useScrollAnimation();

  return (
    <section className="wasp-section">
      <div className="wasp-container">
        <h3 className="wasp-modal-title">{waspData.title}</h3>
        <div className="wasp-modal-image">
          <img src={waspData.images.system} alt={waspData.title} />
        </div>

        <div className="wasp-modal-section">
          <h4 className="wasp-modal-section-title">시스템 개요</h4>
          <p className="wasp-modal-description">{waspData.overview}</p>
        </div>

        <div className="wasp-image-grid">
          <div className="wasp-grid-image">
            <h5 className="wasp-image-title">실시간 모니터링</h5>
            <div className="wasp-image-container">
              <img src={waspData.images.monitoring} alt="모니터링 시스템" />
            </div>
            <p className="wasp-image-description">AI 기반 실시간 말벌 감지 및 추적 시스템</p>
          </div>
          <div className="wasp-grid-image">
            <h5 className="wasp-image-title">퇴치 하드웨어</h5>
            <div className="wasp-image-container">
              <img src={waspData.images.hardware} alt="퇴치 하드웨어" />
            </div>
            <p className="wasp-image-description">친환경 자동 퇴치 시스템 하드웨어</p>
          </div>
        </div>

        <div className="wasp-modal-section">
          <h4 className="wasp-modal-section-title">주요 기능</h4>
          <div className="wasp-feature-grid">
            {waspData.features.map((feature, index) => (
              <div key={index} className="wasp-feature-card">
                <h5>{feature.title}</h5>
                <ul>
                  {feature.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WaspSystem;
